import { render, staticRenderFns } from "./triggerCase.vue?vue&type=template&id=4a0e6014"
import script from "./triggerCase.vue?vue&type=script&lang=js"
export * from "./triggerCase.vue?vue&type=script&lang=js"
import style0 from "./triggerCase.vue?vue&type=style&index=0&id=4a0e6014&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports